import { zhCN, dateZhCN } from 'naive-ui'

/** 全局中文：覆盖组件内默认英文（如 No Data、Please select） */
export const appLocale = {
  ...zhCN,
  DataTable: {
    ...zhCN.DataTable,
    empty: '暂无数据'
  },
  Select: {
    ...zhCN.Select,
    placeholder: '请选择'
  },
  Input: {
    ...zhCN.Input,
    placeholder: '请输入'
  },
  Pagination: {
    ...zhCN.Pagination,
    goto: '跳至',
    selectionSuffix: '项'
  },
  DatePicker: {
    ...zhCN.DatePicker,
    placeholder: '请选择日期',
    startPlaceholder: '开始日期',
    endPlaceholder: '结束日期'
  },
  TimePicker: {
    ...zhCN.TimePicker,
    placeholder: '请选择时间'
  },
  Empty: {
    ...zhCN.Empty,
    description: '暂无数据'
  }
}

export const appDateLocale = dateZhCN

export const TABLE_EMPTY = { description: '暂无数据' }
